<template>
    <div class="x_box A4">
        <div class="x_body">
            <div class="print-header">
                <h3 class="text-center" style="font-weight: bold;">{{company.Name}}</h3>
                <h4 class="text-center">{{$t('stock_in_detail')}}</h4>
                <p class="text-center">{{fromd}} ដល់ {{tod}}</p>
            </div>
            <table class="table table-bordered table-sm no-bor">
                <thead>
                    <tr class="toUpper">
                        <th class="text-center">{{$t('no')}}</th>
                        <th>{{$t('date')}}</th>
                        <th>{{$t('stock_in_no')}}</th>
                        <th>{{$t('item_name')}}</th>
                        <th>Vendor</th>
                        <th>{{$t('branch')}}</th>
                        <th>{{$t('type')}}</th>
                        <th>{{$t('ref_num')}}</th>
                        <th>{{$t('uom')}}</th>
                        <th class="text-right">{{$t('qty')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(gp,gin) in records">
                        <tr :key="gin">
                            <th colspan="10">{{gp.TitleName}}</th>
                        </tr>
                        <tr v-for="(ret, index) in gp.StockInLineListDatas" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{$format(ret.DateApproved,'DD/MM/YYYY')}}</td>
                            <td>{{ret.StockinCode}}</td>
                            <td>{{ret.ItemName}}</td>
                            <td>{{ret.VendorName}}</td>
                            <td>{{ret.BranchName}}</td>
                            <td>{{ret.DocSource}}</td>
                            <td>{{ret.DocSourceNo}}</td>
                            <td class="text-right">{{ret.UomName}}</td>
                            <td class="text-right">{{ret.QuantityIn}}</td>
                        </tr>
                        <tr v-if="isShowFooter" :key="'total'+gin" class="table-active">
                            <th colspan="9" class="text-right">Total</th>
                            <th class="text-right">{{$number(gp.TotalQty,'0,0.[00]')}}</th>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                company: {},
                records: [],
                fromd: '',
                tod: '',
                groupBy: 'ItemCode',
                isShowFooter: false
            };
        },
        created() {
            this.fromd = this.$route.query.from;
            this.tod = this.$route.query.to;
            this.groupBy = this.$route.query.gby;
            this.isShowFooter = this.groupBy == 'ItemCode' ? true : false;
            this.getCompany();
            this.toList();
        },
        methods: {
            getCompany: function () {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                });
            },
            toList() {
                var loading = this.$loading.show();
                this.records = [];
                var req = {
                    FromDate: this.fromd,
                    ToDate: this.tod,
                    GroupBy: this.groupBy,
                    CompanyId: this.$store.state.company.Id
                };
                this.$api().post("report/stockin/detail", req).then(res => {
                    this.records = res.data.Json.StockInDetails;
                }).finally(() => { loading.hide(); });
            }
        }
    };
</script>